package co.maytes.standupbot.dashboard.features.calendar

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.shared.dto.integration.CalendarAvailability

object CalendarPhase {
    fun of(
        loading: Boolean,
        availability: CalendarAvailability,
        errored: Boolean,
        hasEvents: Boolean,
    ): ViewPhase = when {
        loading -> ViewPhase.Loading
        availability != CalendarAvailability.AVAILABLE -> ViewPhase.Error
        errored -> ViewPhase.Error
        !hasEvents -> ViewPhase.Empty
        else -> ViewPhase.Ready
    }
}
